<ng-container *ngIf="field && controlName">
  <!-- [formControlName]="controlName" -->
  <nz-switch
    [ngModel]="value"
    [ngModelOptions]="{ standalone: true }"
    style="width: 100%"
    [nzDisabled]="disabled"
    [disabled]="disabled"
    (ngModelChange)="valueChanged($event)"
    [nzCheckedChildren]="checkedTemplate"
    [nzUnCheckedChildren]="unCheckedTemplate"
  ></nz-switch>
  <ng-template #checkedTemplate
    ><span nz-icon nzType="check"></span
  ></ng-template>
  <ng-template #unCheckedTemplate
    ><span nz-icon nzType="close"></span
  ></ng-template>
</ng-container>
